import { v4 as uuid4 } from "uuid";

export const distanceFormula = (
  distanceInMeters: number | null | undefined,
): number | null => {
  if (
    distanceInMeters === null ||
    distanceInMeters === undefined ||
    isNaN(distanceInMeters)
  ) {
    return null;
  }

  return Math.round(+distanceInMeters / 100) / 10;
};

export const durationInMinutesCeil = (
  durationInSeconds: number | null | undefined,
  keepFloatingPart = false,
): number | null => {
  if (
    durationInSeconds === null ||
    durationInSeconds === undefined ||
    isNaN(+durationInSeconds)
  ) {
    return null;
  }

  return keepFloatingPart
    ? Math.ceil((+durationInSeconds / 60) * 100) / 100
    : Math.ceil(+durationInSeconds / 60);
};

export const durationInMinutesFloor = (
  durationInSeconds: number | null | undefined,
  keepFloatingPart = false,
): number | null => {
  if (
    durationInSeconds === null ||
    durationInSeconds === undefined ||
    isNaN(+durationInSeconds)
  ) {
    return null;
  }

  return keepFloatingPart
    ? Math.floor((+durationInSeconds / 60) * 100) / 100
    : Math.floor(+durationInSeconds / 60);
};

export const percentFormula = (num1: number, num2 = 100): number => {
  return Math.round((num1 * 100) / num2);
};

const maxValueSuggestedByPercent = 1.05;
const maxValueSuggestedByNumber = 5;

export const maxValueSuggestedMaxHelper = (num: number): number => {
  /* dashboard hard-coded value transformation */
  return Math.max(
    Math.ceil(num * maxValueSuggestedByPercent),
    num + maxValueSuggestedByNumber,
  );
};

export const twoPointsAfterDecimal = (num1: number): number => {
  return Math.round(num1 * 100) / 100;
};

export const numericContentCardComparingColoringIndicator = (
  num1: number,
  num2: number,
  percent: number,
): boolean => {
  if (num1 === 0 || num2 === 0) {
    return true;
  }

  const resPer = percentFormula(num1, num2);
  const res = resPer > 100 ? resPer - 100 : 100 - resPer;
  return res >= percent;
};

export const numericValueWithCommas = (num: number | string): string => {
  return (+num).toLocaleString();
};

export const getRandomInt = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const generateGuid = (): string => {
  return uuid4();
};
